import Vuex from 'vuex';
import cloneDeep from 'lodash-es/cloneDeep';
import rPlayer from './rPlayer';
export let stores = {};
export const getPlayerStore = (name = 0) => {
  if (stores[name]) return stores[name];
  stores[name] = new Vuex.Store(cloneDeep(rPlayer));
  return stores[name];
};

